// extracted by mini-css-extract-plugin
export default {"arrow":"ForgotPassword_arrow__49Wth","h1":"ForgotPassword_h1__d5cO8"};